import { Box, Typography } from '@mui/material';

export default function QuickbooksConnectionForm() {
  return <Typography variant="subtitle2">
    <Box>Quickbooks requires an external login to test the connection.</Box>
    <Box>If you haven't logged in yet or want to reconnect with a diffrent user, please click the connect button and a Quickbooks login page will popup.</Box>
    <Box>Once you've logged in you'll be redirected back to this page and will be able to test fully.</Box>
  </Typography>;
}
